(function () {
  'use strict';
  document.querySelectorAll('[data-copy-url]').forEach(function (button) {
    button.hidden = false;
    button.addEventListener('click', async function () {
      var copied = false;
      var url = button.getAttribute('data-copy-url');
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
          copied = true;
        }
      } catch (_) { /* Try the browser's legacy clipboard below. */ }
      if (!copied) {
        var input = document.createElement('textarea');
        input.value = url;
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        try { copied = document.execCommand('copy'); } catch (_) { copied = false; }
        input.remove();
        button.focus();
      }
      var status = document.getElementById(button.getAttribute('aria-describedby'));
      if (status) status.textContent = copied ? button.dataset.success : button.dataset.failure;
    });
  });
})();
